import ReactApexChart from 'react-apexcharts';
import { Container, HeaderCardContent } from './styles';
import { ApexOptions } from 'apexcharts';

type TypePercent = number | 'NaN' | undefined;

interface ITypePercentMap {
  fii: TypePercent;
  action: TypePercent;
  rendaFixa: TypePercent;
  stocks?: TypePercent;
  etfs?: TypePercent;
  reits?: TypePercent;
  crypto?: TypePercent;
}

interface IPropsPortfolioBalanceSheetStatistics {
  percentage: ITypePercentMap;
  strategyPercentage: ITypePercentMap;
}

const num = (value: TypePercent) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function PortfolioBalanceSheetStatistics({
  percentage,
  strategyPercentage,
}: IPropsPortfolioBalanceSheetStatistics) {
  // Categorias da carteira — internacionais (stocks/etfs/reits) e cripto só
  // entram quando têm valor atual ou objetivo definido.
  const categories = [
    { key: 'action', label: '% Ações', color: '#FFA600' },
    { key: 'fii', label: '% FIIs', color: '#EC6643' },
    { key: 'rendaFixa', label: '% Renda Fixa', color: '#99538E' },
    { key: 'stocks', label: '% Stocks', color: '#1FA75B' },
    { key: 'etfs', label: '% ETFs', color: '#0FA3B1' },
    { key: 'reits', label: '% REITs', color: '#7B61FF' },
    { key: 'crypto', label: '% Criptomoedas', color: '#295074' },
  ]
    .map((cat) => ({
      ...cat,
      current: num(percentage[cat.key as keyof ITypePercentMap]),
      objective: num(strategyPercentage[cat.key as keyof ITypePercentMap]),
    }))
    .filter((cat) => cat.current > 0 || cat.objective > 0);

  // columnWidth é relativo ao slot da categoria: com poucas categorias o slot
  // fica largo e as barras saem gordas/espalhadas. Reduzimos o percentual
  // conforme há menos categorias para manter a largura visual proporcional.
  const columnWidth =
    categories.length <= 2
      ? '28%'
      : categories.length === 3
      ? '38%'
      : categories.length === 4
      ? '48%'
      : categories.length === 5
      ? '55%'
      : '60%';

  const graphicDataAction: {
    options: ApexOptions;
    series: ApexAxisChartSeries;
  } = {
    series: [
      {
        name: 'Carteira Atual',
        color: '#EC6643',
        data: categories.map((cat) => ({
          x: cat.label,
          y: cat.current,
          fillColor: cat.color,
        })),
      },
      {
        name: 'Objetivo global',
        color: '#38486B',
        data: categories.map((cat) => ({
          x: cat.label,
          y: cat.objective,
          fillColor: '#38486B',
        })),
      },
    ],
    options: {
      chart: {
        type: 'bar',
      },
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false, // Use true para barras horizontais, se necessário
          columnWidth,
          borderRadius: 5, // Ajuste o raio para bordas arredondadas
        },
      },
      // fill: { colors: ['#EC6643', '#2469a9', '#02CD53'] },
      dataLabels: {
        enabled: true,
      },
      xaxis: {
        categories: categories.map((cat) => cat.label),
      },
      labels: categories.map((cat) => cat.label),
    },
  };

  return (
    <Container>
      <HeaderCardContent>
        <h4>Carteira - Análise Geral</h4>
      </HeaderCardContent>
      <p>Distribuição da carteira</p>

      {/* @ts-ignore */}
      <ReactApexChart
        options={graphicDataAction.options}
        series={graphicDataAction.series}
        type="bar"
        width={'100%'}
        height={250}
      />
    </Container>
  );
}
